<template>
  <div class="container container-bg container-screen">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'container',
};
</script>

<style lang='less' scoped>
.container {
  min-width: 1000px;
  min-height: 500px;

  position: absolute;
  margin: 0 auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
